<template>
  <div v-if="team.uses_veeva_vault && presentation.vaultConfiguration"
       class="d-flex align-middle">
    <img src="/v2/images/veeva/veeva-vault-1.png"
         alt="Imported from Veeva Vault"
         style="height: 20px; width: auto;"
         class="mr-1"/>
    {{ presentation.external_id }}
  </div>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  props: {
    presentation: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapGetters([
      'team',
    ])
  }
}
</script>
